import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE, fillPlaceholders } from '@skylab-shared/utils';
import { AttachmentsSettings, EmailSettings, PrintingsSettings } from './document-send-email-settings';

export type DocumentSendEmailSingleCommandParams =
    & {
        documentId: number;
        printingTemplateId: number;
    }
    & PrintingsSettings
    & {
        emailSettings: EmailSettings;
        attachmentsSettings: AttachmentsSettings;
    };

export type DocumentSendEmailCommandResult = null;

export class DocumentSendEmailSingleCommand extends Command<DocumentSendEmailSingleCommandParams, void> { }

export class DocumentSendEmailSingleCommandHandlerBase implements CommandHandler<DocumentSendEmailSingleCommand, DocumentSendEmailSingleCommandParams, void> {
    private static Url = TaggedUrl.join('documents/:id/emailQueue', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync({ params }: DocumentSendEmailSingleCommand): Promise<void> {
        const url = fillPlaceholders(DocumentSendEmailSingleCommandHandlerBase.Url, { id: params?.documentId });
        await this.http.post<DocumentSendEmailCommandResult>(url, params, { timeout: MS_PER_MINUTE });
    }
}
